import isEqual from 'lodash/isEqual'

const initialQuery = {
  use_facility_id: 0,
  use_child_facility_id: 0,
  start_date: '',
  end_date: '',
  cmc_no: ''
}

const state = {
  query: initialQuery
}

const getters = {
  isEmpty: state => isEqual(state.query, initialQuery)
}

const mutations = {
  SET_QUERY(state, payload) {
    state.query = Object.assign({}, state.query, payload)
  },
  CLEAR_QUERY(state) {
    state.query = initialQuery
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
